import { Box, Typography, Container, Alert, Button } from '@mui/material'
import { RefreshIcon } from 'src/v3/core/icons'
import { useScheduleData } from './hooks/useScheduleData'
import { useWeekNavigation } from './hooks/useWeekNavigation'
import { WeekNavigation } from './components/WeekNavigation'
import { ScheduleGrid } from './components/ScheduleGrid'
import { ScheduleSkeleton } from './components/ScheduleSkeleton'

let LiveClassSchedule = () => {
  let {
    currentWeek,
    weekDisplayText,
    canGoBack,
    canGoForward,
    goToPreviousWeek,
    goToNextWeek,
  } = useWeekNavigation()

  let { scheduleData, loading, error, refetch } = useScheduleData(currentWeek)

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Page Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Typography variant="h4" component="h1">
            Live Classes
          </Typography>
        </Box>
        {/* Week Navigation Skeleton */}
        <WeekNavigation
          weekDisplayText="Loading..."
          canGoBack={false}
          canGoForward={false}
          onPreviousWeek={() => {}}
          onNextWeek={() => {}}
          isLoading={true}
        />
        {/* Schedule Skeleton */}
        <ScheduleSkeleton />
        {/* Loading announcement for screen readers */}
        <Box
          role="status"
          aria-live="polite"
          aria-atomic="true"
          sx={{
            position: 'absolute',
            left: '-10000px',
            width: '1px',
            height: '1px',
          }}
        >
          Loading live class schedule
        </Box>
      </Container>
    )
  }

  if (error) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          role="alert"
          aria-live="assertive"
        >
          {error}
        </Alert>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={refetch}
            aria-label="Reload live class schedule"
          >
            Try Again
          </Button>
        </Box>
      </Container>
    )
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Page Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1" id="page-title">
          Live Classes
        </Typography>
      </Box>
      {/* Week Navigation */}
      <WeekNavigation
        weekDisplayText={weekDisplayText}
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        onPreviousWeek={goToPreviousWeek}
        onNextWeek={goToNextWeek}
        isLoading={loading}
      />
      {/* Schedule Content */}
      {scheduleData && <ScheduleGrid scheduleData={scheduleData} />}
      {/* Status announcement for screen readers */}
      <Box
        role="status"
        aria-live="polite"
        aria-atomic="true"
        sx={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
        }}
      >
        {weekDisplayText} schedule loaded
      </Box>
    </Container>
  )
}

export default LiveClassSchedule
